import * as React from 'react';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { getProfitDetails, getOrdersCount } from './shared/api/user';
import { useState, useEffect } from 'react';

function preventDefault(event) {
  event.preventDefault();
}

export default function Deposits() {
  const [profit, setprofit] = useState([]);
  const [orders, setOrders] = useState([]);

  const init = async () => {
    let prof = await getProfitDetails();
    let orders = await getOrdersCount();
    console.log(orders)
    setOrders(orders.data);
    setprofit(prof.data);
    console.log(prof)
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <div>
      <React.Fragment>
        <Typography component="p" variant="h4">
          Rs. {profit?.todaysSale?.toFixed(2)}
        </Typography>
        <Typography color="text.secondary" sx={{ flex: 1 }}>
          Sales Today
        </Typography>
        <div>
        </div>
      </React.Fragment>
      <React.Fragment>
        <Typography component="p" variant="h4">
          {orders.total || 0}
        </Typography>
        <Typography color="text.secondary" sx={{ flex: 1 }}>
          Completed Orders Today
        </Typography>
        <div>
        </div>
      </React.Fragment>
      <React.Fragment>
        <Typography component="p" variant="h4">
          Rs. {profit?.todaysProfit?.toFixed(2)}
        </Typography>
        <Typography color="text.secondary" sx={{ flex: 1 }}>
          Profit Today
        </Typography>
        <div className='mt-2'>
          <Link disabled color="primary" href="#" onClick={preventDefault}>
            Details
          </Link>
        </div>
      </React.Fragment>
    </div>
  );
}
